/**
 * Authors: mariushirjanu
 * Created: 27/05/2021
 */
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'translate-label',
  template: '{{ textWithLabel }}'
})
export class TranslateLabelComponent implements OnChanges {
  @Input() public key:string;
  @Input() public label:string;

  public textWithLabel:string;

  constructor(
    private translateService:TranslateService
  ) {
    /***/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes?.translate?.currentValue) {
      this.key = changes?.translate?.currentValue;
    }

    if (changes?.label?.currentValue) {
      this.label = changes?.label?.currentValue;
    }

    if (changes?.translate?.currentValue || changes?.label?.currentValue) {
      this.textWithLabel = this.translateService.instant(this.key, { label: this.translateService.instant(this.label) });
    }
  }
}
